import { z } from 'zod/v3';

export const salesVenuesSearchParamsSchema = z.object({
  create: z.boolean().optional(),
  editVenueId: z.string().optional(),
  search: z.coerce.string().optional(),
  page: z.coerce.number().optional(),
});

export type SalesVenuesSearchParamsSchemaType = z.infer<typeof salesVenuesSearchParamsSchema>;
